import type React from 'react';

import { SentryClientInit } from '@/components/shared/SentryClientInit';
import { ConfigProvider } from './ConfigProvider';
import { QueryClientProvider } from './QueryClientProvider';
import { SettingsProvider } from './SettingsProvider';

export const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	return (
		<QueryClientProvider>
			<ConfigProvider>
				<SentryClientInit />
				<SettingsProvider>{children}</SettingsProvider>
			</ConfigProvider>
		</QueryClientProvider>
	);
};
